export default __webpack_public_path__ + "static/media/certbot.36ba9123.svg";